import React,{useEffect} from 'react';
import "./TaxiDecision.css";
import Header from '../../../components/Header';
// import prevIcon from "../../../../assets/icons/coloredPrev.svg";
import icon from "../../../../assets/icons/ChatText.svg"
import { useNavigate,useLocation } from 'react-router-dom';
import axios from 'axios';
import useAuth from '../../../../customHooks/useAuth';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../../common/baseUrl';
import axiosInstance from '../../../../axiosInstance/axiosInstance';
import { HOTEL_TIMEZONE } from "../../../../common/hotelTime";


export default function TaxiDecision() {

  const navigate = useNavigate();
  const location = useLocation();
 
  // Setting UP Cab Request Data
  const cabRequestData = location.state?.cabRequestData || {};
  const hotelId = location.state?.hotelId || "";
  const bookingId = location.state?.bookingId || "";
  const requestId = location.state?.requestId || "";

  // console.log("Cab Request Data: " , cabRequestData);

  // Refresh Handle
  useAuth();
 

  // Check If It is Empty then Go To the Bookings
  useEffect(()=>{
  const checkData = ()=>{
    if(hotelId==="" || bookingId==="" ||  Object.keys(cabRequestData).length === 0){ 
      navigate("/bookings",{state : {activeRequests : "requests"}});
    }
  }
  checkData();
  },[]);


  // Function to format the date (e.g., "07 Oct")
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    return `${day} ${month}`;
  };

  // Function to format the time (e.g., "22:11")
  const formatTime = (dateString) => {
    const date = new Date(dateString);

    return date.toLocaleTimeString([], {
            timeZone: HOTEL_TIMEZONE, hour: '2-digit', minute: '2-digit' });
  };

 

  

  // Reject Fee
  const handleRejectFee = async()=>{
    try{
      const response = await axiosInstance.patch(`/api/v1/users/${cabRequestData.user_id}/bookings/${bookingId}/booked-rooms/${cabRequestData.booked_room_id}/guest-requests/post-checkin/cab-request/user-verdict?guest_request_id=${cabRequestData.guest_request_id}`,{
        accepted_by_guest : false
    });
    // console.log("Price Rejected",response.data);
    toast.success("Taxi Fee Rejected Successfully");
    navigate("/bookings",{state : {activeRequests : "requests"}});


    }catch(error){
      toast.error(error.response.data.message);
      console.log(error);
    }

  }
  
  // Accept Fee 
  const handleAcceptFee = async()=>{
    try{
      const response = await axiosInstance.patch(`/api/v1/users/${cabRequestData.user_id}/bookings/${bookingId}/booked-rooms/${cabRequestData.booked_room_id}/guest-requests/post-checkin/cab-request/user-verdict?guest_request_id=${cabRequestData.guest_request_id}`,{
        accepted_by_guest : true
    });
    // console.log("Price Accepted",response.data);
    toast.success("Taxi Fee Accepted Successfully");
    navigate("/bookings",{state : {activeRequests : "requests"}});
    }catch(error){
      toast.error(error?.response?.data?.message || "Some Error Occured");
      console.log(error)
    }

  }

  // Cancel Request
  const closeRequest = async()=>{
    try{
      const response = await axiosInstance.put(`/api/v1/users/${cabRequestData.user_id}/guest-requests/${requestId}/close`);
      // console.log("Request Closed By",response.data);
 
      toast.success("Cab Request Closed Successfully");
      navigate("/bookings",{state : {activeRequests : "requests"}});
    }catch(error){
      toast.error(error?.response?.data?.message || "Some Error Occured");
      console.log(error);
    }

  }

  // Edit Request
  // const handleEditRequest = async()=>{
  //   navigate("/postCheckInTaxi",{state :{
  //     bookingId : bookingId,
  //     hotelId : hotelId,
  //     bookedRoomId : cabRequestData.booked_room_id,
  //     hotelAddress : cabRequestData.pick_up_location,
  //     update : "update",
  //     location : cabRequestData.pick_up_location,
  //     time :   cabRequestData.time_of_arrival,
  //     people : cabRequestData.number_of_people,
  //     requestId : cabRequestData.guest_request_id,
  //     cabRequestData : cabRequestData,
  //     dropLocation : cabRequestData.drop_off_location,

  //   }})
  // }

  // Function For Handlimg Status
  const renderCabRequestButtons = () => {
    if (["Completed_Hotel", "Completed_Guest", "Declined_Guest", "Declined_Hotel", "Closed_Guest"].includes(cabRequestData.status)) {
      return <div></div>;
    }
  
    if (cabRequestData.status === "Pending_Hotel") {
      return (
        <div className="fee-btns">
          {/* <div className="edit-btn">
            <button onClick={handleEditRequest}>Edit Request</button>
          </div> */}
          <div className="cancel-btn">
            <button onClick={closeRequest}>Cancel Request</button>
          </div>
        </div>
      );
    }
  
    if (cabRequestData.status === "Pending_Guest") {
      return (
        <div className="fee-btns">
          <div className="reject-btn">
            <button onClick={handleRejectFee}>Reject Fee</button>
          </div>
          <div className="accept-btn">
            <button onClick={handleAcceptFee}>Accept Fee</button>
          </div>
        </div>
      );
    }
  
    if (["InProgress_Hotel", "Scheduled_Hotel"].includes(cabRequestData.status)) {
      return (
        <div className="fee-btns">
          <div className="cancel-btn">
            <button onClick={closeRequest}>Cancel Request</button>
          </div>
        </div>
      );
    }
  
    return <div></div>;
  };
  


  return (
    <div className='taxidecison'>
      <Header title="Book your cab to your stay" para="Reserve a comfortable and reliable transportation option for your convenient journey." />
      <div className='cab-decesion'>

 

        {/* Cab Pickup Message */}
        <div className="cab-pickup-msg">    
          {/* Pickup Location */}
          <div className="pickup-location">
            <div className="msg-header">
              <h4>Pick Up Location</h4>
            </div>
            <div className="pickup-msg">
              <h6>{cabRequestData.pick_up_location}</h6>
            </div>
          </div>

          {/* Drop of Location */}
          <div className="pickup-location">
          <div className="msg-header">
              <h4>Drop off Location</h4>
            </div>
            <div className="pickup-msg">
              <h6>{cabRequestData.drop_off_location}</h6>
            </div>
          </div>


            
          {/* Cab Time Message */}
          <div className="cab-time">
            <div className="msg-header">
                <h4>Date of Trip</h4>
            </div>
            <div className="cab-time-msg">
              <h6>{formatDate(cabRequestData.time_of_arrival)}</h6>
            </div>
            <div className="msg-header">
                <h4>When do you want cab</h4>
            </div>
            <div className="cab-time-msg">
              <h6>{formatTime(cabRequestData.time_of_arrival)}</h6>
            </div>

            {/* People */}
            <div className="msg-header">
                <h4>Number Of People</h4>
            </div>
            <div className="cab-time-msg">
              <h6>{cabRequestData.number_of_people}</h6>
            </div>


            
            {cabRequestData.driver_name && (
              <>
                <div className="msg-header">
                  <h4>Driver Assigned</h4>
                </div>

                <div className="cab-time-msg">
                  <h6>{cabRequestData.driver_name}</h6>
                </div>
              </>
            )}

            {cabRequestData.vehicle_number && (
              <>
                <div className="msg-header">
                  <h4>Vehicle Number</h4>
                </div>

                <div className="cab-time-msg">
                  <h6>{cabRequestData.vehicle_number}</h6>
                </div>
              </>
            )}

            {cabRequestData.driver_contact && (
              <>
                <div className="msg-header">
                  <h4>Driver Contact</h4>
                </div>

                <div className="cab-time-msg">
                  <h6>{cabRequestData.driver_contact}</h6>
                </div>
              </>
            )}

             
          </div>

          {/* Cab Fee Requested */}
          {cabRequestData.price!=0 && cabRequestData.price!=null && 
            <div className="cab-fee">
              <div className="msg-header">
                <h4>Fee Requested By Hotel</h4>
              </div>
              <div className="cab-fee-msg">
                <h6>
                  ₹ {cabRequestData.price}
                </h6>
              </div>
            </div>
          }
          {
            cabRequestData?.price===0 && (
                <div className="cab-fee">
                <div className="msg-header">
                    <h4>Fee Requested By Hotel</h4>
                </div>
                <div className="cab-fee-msg">
                    <h6>
                        ₹ {cabRequestData.price}
                    </h6>
                </div>
            </div>

            )
          }

        </div>

        {/* Hotel Remark */}
        {cabRequestData.remarks &&
          <div className="hotel-remark">
              <div className="icon-hotel">
                  <img src={icon} alt='' />
              </div>
              <div className="hotel-msg">
                  <div className="hotel-msg-header">
                      <h5>
                          Remarks By Hotel : 
                      </h5>
                      <p>
                        {cabRequestData.remarks}
                      </p>
                      <p>
                        Driver Phone No. : {cabRequestData.driver_contact} Car : {cabRequestData.vehicle_number}
                      </p>
                  </div>
              </div>
          </div>
        }

        {/* Fee Buttons */}
        {
          renderCabRequestButtons()
        }
 
    


      </div>

    </div>
  )
}
